// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file notifications/notification_request.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Platform } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';

/**
 * Describes the file notifications/notification_request.proto.
 */
export const file_notifications_notification_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Cihub3RpZmljYXRpb25zL25vdGlmaWNhdGlvbl9yZXF1ZXN0LnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCIyCgxOb3RpZmljYXRpb24iIgoJVG9rZW5UeXBlEgsKB01FU1NBR0UQABIICgRWT0lQEAEiywEKGFJlZ2lzdGVyUHVzaFRva2VuUmVxdWVzdBITCgtkZXZpY2VUb2tlbhgBIAEoCRJACgp0b2tlblR5cGVzGAIgAygOMiwuY29tLmdlbS5iZmYuY29udHJhY3QuTm90aWZpY2F0aW9uLlRva2VuVHlwZRI0CgxwbGF0Zm9ybVR5cGUYAyABKA4yHi5jb20uZ2VtLmJmZi5jb250cmFjdC5QbGF0Zm9ybRIVCghkZXZpY2VJZBgEIAEoCUgAiAEBQgsKCV9kZXZpY2VJZCKYAQobVW5yZWdpc3RlclB1c2hUb2tlbnNSZXF1ZXN0EhMKC2RldmljZVRva2VuGAEgASgJEkAKCnRva2VuVHlwZXMYAiADKA4yLC5jb20uZ2VtLmJmZi5jb250cmFjdC5Ob3RpZmljYXRpb24uVG9rZW5UeXBlEhUKCGRldmljZUlkGAMgASgJSACIAQFCCwoJX2RldmljZUlkInsKJVVucmVnaXN0ZXJQdXNoVG9rZW5zQnlEZXZpY2VJZFJlcXVlc3QSQAoKdG9rZW5UeXBlcxgBIAMoDjIsLmNvbS5nZW0uYmZmLmNvbnRyYWN0Lk5vdGlmaWNhdGlvbi5Ub2tlblR5cGUSEAoIZGV2aWNlSWQYAiABKAlCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_model]
  );

/**
 * @generated from message com.gem.bff.contract.Notification
 */
export type Notification = Message<'com.gem.bff.contract.Notification'> & {};

/**
 * Describes the message com.gem.bff.contract.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> =
  /*@__PURE__*/
  messageDesc(file_notifications_notification_request, 0);

/**
 * @generated from enum com.gem.bff.contract.Notification.TokenType
 */
export enum Notification_TokenType {
  /**
   * @generated from enum value: MESSAGE = 0;
   */
  MESSAGE = 0,

  /**
   * @generated from enum value: VOIP = 1;
   */
  VOIP = 1,
}

/**
 * Describes the enum com.gem.bff.contract.Notification.TokenType.
 */
export const Notification_TokenTypeSchema: GenEnum<Notification_TokenType> =
  /*@__PURE__*/
  enumDesc(file_notifications_notification_request, 0, 0);

/**
 * @generated from message com.gem.bff.contract.RegisterPushTokenRequest
 */
export type RegisterPushTokenRequest = Message<'com.gem.bff.contract.RegisterPushTokenRequest'> & {
  /**
   * @generated from field: string deviceToken = 1;
   */
  deviceToken: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.Notification.TokenType tokenTypes = 2;
   */
  tokenTypes: Notification_TokenType[];

  /**
   * @generated from field: com.gem.bff.contract.Platform platformType = 3;
   */
  platformType: Platform;

  /**
   * @generated from field: optional string deviceId = 4;
   */
  deviceId?: string;
};

/**
 * Describes the message com.gem.bff.contract.RegisterPushTokenRequest.
 * Use `create(RegisterPushTokenRequestSchema)` to create a new message.
 */
export const RegisterPushTokenRequestSchema: GenMessage<RegisterPushTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_notifications_notification_request, 1);

/**
 * @generated from message com.gem.bff.contract.UnregisterPushTokensRequest
 */
export type UnregisterPushTokensRequest =
  Message<'com.gem.bff.contract.UnregisterPushTokensRequest'> & {
    /**
     * @generated from field: string deviceToken = 1;
     */
    deviceToken: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.Notification.TokenType tokenTypes = 2;
     */
    tokenTypes: Notification_TokenType[];

    /**
     * @generated from field: optional string deviceId = 3;
     */
    deviceId?: string;
  };

/**
 * Describes the message com.gem.bff.contract.UnregisterPushTokensRequest.
 * Use `create(UnregisterPushTokensRequestSchema)` to create a new message.
 */
export const UnregisterPushTokensRequestSchema: GenMessage<UnregisterPushTokensRequest> =
  /*@__PURE__*/
  messageDesc(file_notifications_notification_request, 2);

/**
 * @generated from message com.gem.bff.contract.UnregisterPushTokensByDeviceIdRequest
 */
export type UnregisterPushTokensByDeviceIdRequest =
  Message<'com.gem.bff.contract.UnregisterPushTokensByDeviceIdRequest'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.Notification.TokenType tokenTypes = 1;
     */
    tokenTypes: Notification_TokenType[];

    /**
     * @generated from field: string deviceId = 2;
     */
    deviceId: string;
  };

/**
 * Describes the message com.gem.bff.contract.UnregisterPushTokensByDeviceIdRequest.
 * Use `create(UnregisterPushTokensByDeviceIdRequestSchema)` to create a new message.
 */
export const UnregisterPushTokensByDeviceIdRequestSchema: GenMessage<UnregisterPushTokensByDeviceIdRequest> =
  /*@__PURE__*/
  messageDesc(file_notifications_notification_request, 3);
